<template>
  <!-- eslint-disable -->
  <div class="text">
    <h2 class="center">予約システム利用規約および予約に関する注意事項</h2>
    <h3>＜予約システム利用規約＞</h3>
    <h4>第1条（目的）</h4>
    <p>本規約は、株式会社ぐるなび（以下「当社」といいます）が提供する「台帳予約システム」（詳細は次条にて定めるものとし、以下「本システム」といいます）を利用する者（以下「ユーザー」といいます）と当社との間に適用される条件を定めることを目的とします。</p>

    <h4>第2条（定義）</h4>
    <p>
      本規約における用語の定義は、本規約中に別段の定めがある場合を除き、次の各号に掲げるとおりとします。<br>
      (1) 対象飲食店<br>
      当社との間で本システムの導入にかかる契約をする飲食店<br>
      (2) 来店予約<br>
      対象飲食店への来店および当該飲食店が提供する飲食サービス（テイクアウトを含む）の利用にかかる予約<br>
      (3) 予約申込み<br>
      来店予約の申込み<br>
      (4) 本システム<br>
      ユーザーの対象飲食店に対する予約申込みにかかる意思表示およびユーザーと対象飲食店との間における予約申込みに関する各種連絡を行うためのシステム
    </p>

    <h4>第3条（適用範囲、利用条件）</h4>
    <p>
      1. ユーザーが本システムを利用した場合には、本規約に同意したものとみなします。<br>
      2. 本システムの詳細（本システムの機能、デザイン等を含みますが、これに限られません。以下同じ）および利用にかかる条件等は、本規約のほか、当社が別途定める条件（以下、本規約と併せて「本規約等」といいます）によるものとします。<br>
      3. 当社は、本システムの詳細を随時見直すことができるものとします。
    </p>

    <h4>第４条（本システムにかかる責任）</h4>
    <p>
      1. 当社の責任は、本システムの提供に限られ、これ以外については、本規約で定める場合を除き、一切の責任を負いません。<br>
      2. ユーザーと対象飲食店との間でトラブル、紛争等（以下「紛争等」といいます）が生じた場合、ユーザーは、当該紛争等を対象飲食店との間で直接解決するものとし、当社は一切の責任を負いません。<br>
      3. ユーザーは、来店予約・飲食サービスその他対象飲食店に関する質問、クレーム等の一切については、当該飲食店に対して直接行うものとし、当社はこれらに対応する責任を負わないものとします。
    </p>

    <h4>第５条（ユーザーの責任）</h4>
    <p>
      1. ユーザーは、本システムの利用にあたっては、本規約等のほか、当社の定める手順・セキュリティ手段を遵守するものとし、この遵守を怠った場合その他当社が本システムの運営上不適当と判断した場合、当社は、当該行為を停止させ、または本システムの利用の停止および法的措置を含む損害賠償等必要な措置を取ることができるものとします。<br>
      2. ユーザーは、対象飲食店により本システムに予め表示された条件（コース料金にかかる規定、キャンセル規定等を含みますがこれらに限られません）に同意して予約申込を行うものとします。<br>
      3. ユーザーは、本システムの利用に際し、自ら行った行為について責任を負うものとし、第三者に損害を与えた場合、自己の責任と費用負担で解決するものとします。
    </p>

    <h4>第６条（一時停止）</h4>
    <p>
      当社は、次の各号のいずれか該当する場合、ユーザーへの予告なく本システムの全部または一部の提供を一時停止できるものとします。 この場合において、ユーザーに損害や不利益が発生しても、当社はその賠償を負担しないものとします。<br>
      （1）定期的または当社が緊急と判断したときに行うシステム・回線の保守、更新<br>
      （2）落雷、火災、停電等の不可抗力事由やサーバー攻撃などにより本システムの提供が困難なとき<br>
      （3）上記のほか、不測の事態により本システムの提供が困難なとき
    </p>

    <h4>第７条（免責）</h4>
    <p>
      1. 当社は、ユーザーに対し、本システムにおいて提供される情報の正確性、信頼性等につき一切保証しないものとし、当該情報に起因してユーザーに発生した損害について、一切の責任を負いません。<br>
      2. 当社は、ユーザーが本規約等に違反したことによって生じた損害について、一切の責任を負いません。<br>
      3. 当社は、本システムに関して、不具合やエラー等が生じたとしても責任を負いません。<br>
      4. ユーザーは、本システムのセキュリティ機能において、現時点での技術上取れる水準で安全かつ適切な措置を取ったとしてもなお限界があること、当社がユーザーのプライバシーや秘密等を完全または万全に保つことの保証ができないことを了解の上、本システムを利用するものとします。<br>
      5. 当社は、対象飲食店の責に帰すべき事由によるユーザーに関する情報の流出、消失等により発生した損害について、当社の故意および重過失による場合のほかは一切責任を負いません。
    </p>

    <h4>第８条（準拠法、合意管轄）</h4>
    <p>
      1. 本規約は、日本法に基づき解釈されるものとします。<br>
      2. 本規約に関し訴訟の必要が生じた場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
    </p>

    <h4>第９条（規約の改訂等）</h4>
    <p>
      1. 当社は、ユーザーの一般の利益に適合する場合その他当社が本規約の変更が必要であると合理的に判断した場合、本規約をユーザーに対し予告なく任意に改定できるものとし、本規約の改定は、改定後の本規約を本サイトに掲示したときにその効力を生じるものとします。この場合、ユーザーは改定後の規約に従うものとします。<br>
      2. 前項の定めにかかわらず、当該本規約の変更が、ユーザーの権利または義務に重大な影響を及ぼすものである場合、当社は、所定の方法（本サイト上の所定の箇所へ掲載する方法を含みますが、これにかぎられません）により本規約を変更する旨、変更内容および改定後の本規約の効力発生日をユーザーに対して通知するものとします。
    </p>

    <h3>＜予約に関する注意事項＞</h3>

    <h4>予約申込みおよび予約成立について</h4>
    <p>
      ・本サイトの予約情報入力画面の「予約する」ボタンをクリックすると、予約申込みが完了します。予約確定後、本システムから自動的に送信する「予約確定メール」に記載されている内容のご確認をお願いします。<br>
      ・予約申込みの際は本注意事項および対象飲食店が定めるキャンセル規定をよくお読みください。<br>
      ・「予約確定メール」受信のため、迷惑メール対策でドメイン指定受信を設定されている方は、@gnavi.co.jpを受信するよう設定をしてください。
    </p>

    <h4>無断キャンセルについて</h4>
    <p>
      ・予約申込後の無断キャンセルは、お店への迷惑行為になります。予約完了後、やむを得ない事情により予約内容のキャンセル・変更等が必要となった場合は、必ずお客様ご自身にて対象飲食店に直接ご連絡いただきますようお願いいたします。<br>
      ・無断キャンセルされた場合、お店からお客様にキャンセル料を請求させて頂く場合がございます。
    </p>

    <h4>消費税について</h4>
    <p>
      すべての価格表記（コース料金のほか、キャンセル料金、チャージ料金含む）につきましては、ご来店時の消費税率が適用されます。<br>
      詳細は店舗にお問い合わせください。
    </p>

    <h4>個人情報の取扱いについて</h4>
    <p>
      お預かりした個人情報は、お問合わせ対応、予約の手続き、およびその状況管理、顧客台帳の作成、ご連絡、ご予約者の属性および構成の把握、ご来店時の本人確認、各種履歴の分析、特定の個人を識別できない統計データの作成のために利用いたします。<br>
      また、上の利用目的の達成に必要な範囲で株式会社ぐるなびに提供いたします。なお、法令に定める場合を除き、ご本人の同意なく、お知らせした以外の目的での利用、第三者提供をいたしません。
    </p>

    <span>2019年6月27日</span>
  </div>
  <!-- eslint-disable -->
</template>

<script>
/**
 * 利用規約モーダル日本語テキスト
 */
export default {
  name: 'JpText',
}
</script>

<style lang="postcss" scoped>
.text {
  white-space: normal;
}

h2 {
  font-size: 18px;
}

h2,
h3,
p {
  margin-bottom: 16px;
}

.center {
  text-align: center;
}
</style>
